var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-slider"},[_c('div',{staticClass:"logo-slider-wrapper"},[_c('div',{staticClass:"d-inline-flex logo-slider-inner align-items-center",class:{
        'logo-slider-left': _vm.direction == 'left',
        'logo-slider-right': _vm.direction == 'right',
      },style:(_vm.getStyle())},_vm._l((_vm.items),function(item,index){return _c('v-img',{key:index,attrs:{"src":item || '',"alt":"logo","contain":"","eager":""}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }